import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import { formatarDataSimples } from '@spark/utils/formatters';

export const getTabelaVeiculoVinculoColumns = (onDelete, loadingDeleteId) => [
  {
    id: 'numeroFrota',
    accessorKey: 'numeroFrota',
    header: 'Número Frota',
    size: 130,
    cell: ({ row }) => <TruncatedText value={row.original.numeroFrota || '-'} maxLength={14} />
  },
  {
    id: 'placa',
    accessorKey: 'placa',
    header: 'Placa',
    size: 110,
    cell: ({ row }) => <TruncatedText value={row.original.placa || '-'} maxLength={12} />
  },
  {
    id: 'segmento',
    accessorKey: 'segmento',
    header: 'Segmento',
    size: 120,
    cell: ({ row }) => <TruncatedText value={row.original.segmento || '-'} maxLength={16} />
  },
  {
    id: 'modelo',
    accessorKey: 'modelo',
    header: 'Modelo',
    size: 140,
    cell: ({ row }) => <TruncatedText value={row.original.modelo || '-'} maxLength={18} />
  },
  {
    id: 'data',
    accessorKey: 'data',
    header: 'Data Vínculo',
    size: 120,
    cell: ({ row }) => (row.original.data ? formatarDataSimples(row.original.data) : '-')
  },
  {
    id: 'usuarioCriacao',
    accessorKey: 'usuarioCriacao',
    header: 'Usuário',
    size: 140,
    cell: ({ row }) => <TruncatedText value={row.original.usuarioCriacao || '-'} maxLength={18} />
  },
  {
    id: 'acoes',
    header: 'Ações',
    size: 80,
    cell: ({ row }) => (
      <Tooltip dir="top" text="Excluir vínculo">
        <span className="d-inline-block">
          <ButtonWithLoading
            variant="outline-danger"
            size="sm"
            loading={loadingDeleteId === row.original.id}
            disabled={loadingDeleteId === row.original.id}
            onClick={(event) => {
              event.stopPropagation();
              onDelete(row.original.id);
            }}
          >
            <Icon name="trash" size={16} />
          </ButtonWithLoading>
        </span>
      </Tooltip>
    ),
    enableSorting: false
  }
];
